import { useSeo } from "../hooks/useSeo";
import { Btn, Eyebrow } from "../components/Bits";

export default function NotFound() {
  useSeo({ title: "Page not found | MAKO Mats" });

  return (
    <div data-testid="not-found-page" className="mx-auto max-w-[1400px] px-6 py-32 lg:px-10">
      <Eyebrow>404</Eyebrow>
      <h1 className="mt-7 font-display text-4xl font-bold uppercase leading-[1] tracking-tight text-[#111111] sm:text-5xl">
        That page does not exist
      </h1>
      <p className="mt-7 max-w-xl text-sm leading-relaxed text-[#3B3B3B]">
        The link may be out of date. Explore the range or tell us about your facility.
      </p>
      <div className="mt-11 flex flex-col gap-3 sm:flex-row">
        <Btn to="/mats">Explore the range</Btn>
        <Btn to="/contact" variant="outline">
          Request a quote
        </Btn>
      </div>
    </div>
  );
}
